<template>
	<div>
		<div class="coupon" @click="getCouponShow">
			<div class="left">
				<img src="@/assets/image/internal/coupon/coupon_one.webp" alt="" />
				<span>Cupón</span>
			</div>
			<div class="right">
				<span
					v-if="confirmarObject.confirmarSendAmount"
					:style="{
						color: confirmarObject.confirmarCouponType == 4 ? '#DC2B42' : '#9053f7',
					}"
				>
					{{
						confirmarObject.confirmarSendAmount
							? (confirmarObject.confirmarCouponType == 4 ? '+' : '-') +
							  ' $ ' +
							  addComma(confirmarObject.confirmarSendAmount)
							: ''
					}}
				</span>
				<template v-else>
					<span v-if="couponData.total && couponData.total_limit != 0">
						{{ couponData.total_limit }} disponible
						{{ couponData.total_limit > 1 ? '(s)' : '' }}
					</span>
					<span v-else-if="couponData.total && couponData.total_limit == 0">
						0 disponible
					</span>
					<span v-else-if="couponData.total == 0">No hay cupón</span>
				</template>
				<img src="@/assets/image/internal/coupon/coupon_two.webp" alt="" />
			</div>
		</div>
		<!-- coupon -->
		<van-popup round v-model="couponShow" position="bottom" :close-on-click-overlay="false">
			<div class="title">
				<h1>Cupón</h1>
				<div class="right">
					<span @click="gotoCouponInfomation">Instrucción</span>
					<img src="@/assets/image/internal/initialconfirm/coupon_eight.png" alt="" @click="handleCancelar" />
				</div>
			</div>
			<template v-if="couponData.total && couponData.total_limit != 0">
				<div class="sun_title" v-if="tip == 'payment'">
					<h1>Pendiente de pago:</h1>
					<div class="right">
						<span
							:style="
								changeObject.changeId && oldRepayAmount ? { 'text-decoration': 'line-through', fontSize: '.24rem' } : ''
							"
						>
							{{ oldRepayAmount ? '$' + addComma(oldRepayAmount) : '' }}
						</span>

						<span v-if="changeObject.changeId" style="color:#9053f7">
							&nbsp;&nbsp; {{ repayAmount ? '$' + addComma(repayAmount) : 0 }}
						</span>
					</div>
				</div>

				<div class="listClass">
					<div class="coupon_list" v-for="(item, index) in couponData.data" :key="index">
						<div class="left">
							<img v-if="item.coupon_type == 1" src="@/assets/image/internal/initialconfirm/coupon_three.webp" alt="" />
							<img
								v-else-if="item.coupon_type == 4"
								src="@/assets/image/internal/initialconfirm/coupon_five.webp"
								alt=""
							/>
							<img v-else-if="item.coupon_type == 8" src="@/assets/image/internal/payment/coupon_five.webp" alt="" />
							<img v-else-if="item.coupon_type == 9" src="@/assets/image/internal/payment/coupon_green.webp" alt="" />

							<!-- distribute_type==2 Hay un porcentaje -->
							<div class="one" v-if="item.coupon_type == 9">
								{{ item.distribute_type == 2 ? '-' + item.distribute_per + '%' : addComma(item.send_amount) }}
							</div>
							<div class="one" v-else-if="item.coupon_type == 8">-100%</div>
							<div class="one" v-else>{{ addComma(item.send_amount) }}</div>

							<div class="two" v-if="item.coupon_type == 1">Descuento</div>
							<div class="two" v-else-if="item.coupon_type == 4">
								Monto Extra
							</div>
							<div class="two" v-else-if="item.coupon_type == 8">
								Comisión
							</div>
							<div class="two" v-else-if="item.coupon_type == 9">
								Exención
							</div>
						</div>
						<div class="right">
							<img v-if="item.coupon_type == 1" src="@/assets/image/internal/initialconfirm/coupon_four.webp" alt="" />
							<img
								v-else-if="item.coupon_type == 4"
								src="@/assets/image/internal/initialconfirm/coupon_six.webp"
								alt=""
							/>
							<img v-else-if="item.coupon_type == 8" src="@/assets/image/internal/payment/coupon_six.webp" alt="" />
							<img
								v-else-if="item.coupon_type == 9"
								src="@/assets/image/internal/payment/coupon_greenOther.webp"
								alt=""
							/>
							<div class="one">
								<div class="one_left">
									<div class="one_top" v-if="item.use_rule">
										{{ item.use_rule }}
									</div>
									<div class="one_top" v-else>
										Reducir el 100% de comisión de pago de un pedido
									</div>
									<div class="one_bottom">
										Vencimiento: {{ timeFunction(item.effective_date) }} -
										{{ timeFunction(item.expire_date) }}
									</div>
								</div>
								<van-radio-group v-model="radio">
									<van-radio :name="item.id" @click="handleChange(item)">
										<template #icon="props">
											<img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
										</template>
									</van-radio>
								</van-radio-group>
							</div>
						</div>
					</div>
				</div>
				<div class="button_common">
					<button class="button_left" @click="handleCancelar">Cancelar</button>
					<button class="button_right" @click="handleConfirmar">
						Confirmar
					</button>
				</div>
			</template>
			<img
				v-else-if="couponData.total && couponData.total_limit == 0"
				src="@/assets/image/internal/coupon/coupon_nine_other.webp"
				alt=""
				class="coupon_nine"
			/>
			<img
				v-else-if="couponData.total == 0"
				src="@/assets/image/internal/coupon/coupon_nine.webp"
				alt=""
				class="coupon_nine"
			/>
		</van-popup>
	</div>
</template>

<script>
	import { timeFunction, addComma } from '@/utils/internal'
	export default {
		data() {
			return {
				couponShow: false,
				radio: '',
				inactiveIcon: require('@/assets/image/internal/coupon/coupon_seven1.webp'),
				activeIcon: require('@/assets/image/internal/coupon/coupon_seven.webp'),
				changeObject: {},
				confirmarObject: {},
				repayAmount: '',
			}
		},
		props: {
			couponData: Object,
			confirmarShow: Boolean,
			stagesObject: Object,
			orderHomeInfo: Object,
			oldRepayAmount: Number,
			tip: String,
		},
		created() {},
		mounted() {},
		methods: {
			addComma,
			timeFunction,
			gotoCouponInfomation() {
				window.android.gotoCouponInfomation()
			},
			//打开优惠券弹窗
			getCouponShow() {
				this.couponShow = true
				this.radio = this.confirmarObject.confirmarId
				this.changeObject.changeId = null
			},
			processedValue(value) {
				if (
					value
						.slice(1)
						.split('0')
						.join('') === ''
				) {
					// 除最高位都为0
					return value
				} else {
					// 最高位加1，其余位数返回0
					const highestDigit = Number(value[0])
					const newValue = highestDigit + 1 + '0'.repeat(value.length - 1)
					return Number(newValue)
				}
			},
			//选择优惠券
			handleChange(item) {
				this.changeObject = {
					changeSendAmount: item.send_amount,
					changeId: item.id,
					changeCouponType: item.coupon_type,
					changeDistributeType: item.distribute_type,
				}

				if (this.tip == 'payment') {
					// 8 To reduce or waive handling fees (separate reduction or exemption of handling fees)   1 reduction      9 default interest
					if (item.coupon_type == 1) {
						if (this.stagesObject.repayAmount - item.send_amount < 0) {
							this.repayAmount = 0
						} else {
							this.repayAmount = this.stagesObject.repayAmount - item.send_amount
						}
					} else if (item.coupon_type == 9) {
						if (item.distribute_type == 1) {
							if (item.send_amount <= this.orderHomeInfo.penalty_amount) {
								this.repayAmount = this.stagesObject.repayAmount - item.send_amount
							} else {
								this.repayAmount = this.stagesObject.repayAmount - this.orderHomeInfo.penalty_amount
							}
						} else {
							//Round up (if the calculated value is 660, take 700)
							let string = ((this.orderHomeInfo.penalty_amount * item.distribute_per) / 100).toString()
							let quzhenString = ''
							if (string.indexOf('.') > -1) {
								quzhenString = string.substring(0, string.indexOf('.')) //Rounding
							} else {
								quzhenString = string
							}
							let newString = this.processedValue(quzhenString)
							this.$emit('newStringEmit', newString)
							this.repayAmount = this.stagesObject.repayAmount - newString
						}
					} else if (item.coupon_type == 8) {
						this.repayAmount = this.stagesObject.repayAmount
					}
				}
			},

			//Coupon Confirmation
			handleConfirmar() {
				this.confirmarObject = {
					confirmarSendAmount: this.changeObject.changeSendAmount,
					confirmarId: this.changeObject.changeId,
					confirmarCouponType: this.changeObject.changeCouponType,
					confirmarDistributeType: this.changeObject.changeDistributeType,
				}
				this.$emit('confirmarEmit', this.confirmarObject)

				this.couponShow = false
				if (this.tip == 'payment') {
					if (this.changeObject.changeId) {
						this.$emit('update:confirmarShow', true)
					}
				} else {
					this.$parent.getCalculate(this.radio)
				}
			},
			//Coupon cancellation
			handleCancelar() {
				this.couponShow = false
			},
		},
	}
</script>
<style lang="scss" scoped>
	.coupon {
		height: 0.9rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 0.4rem;
		color: #333;
		padding-top: 0.03rem;
		margin-top: -0.1rem;
		border-radius: 0 0 0.16rem 0.16rem;
		margin-bottom: 0.3rem;
		background: #fff;
		.left {
			font-size: 0.28rem;
			display: flex;
			align-items: center;
			justify-content: center;
			img {
				width: 0.36rem;
				margin-right: 0.2rem;
			}
		}
		.right {
			font-size: 0.26rem;
			display: flex;
			align-items: center;
			img {
				width: 0.26rem;
				margin-left: 0.2rem;
			}
		}
	}

	.van-popup {
		padding: 0.4rem 0.28rem 0.54rem;
		box-sizing: border-box;
		overflow-y: scroll;
		background: #f3f5f9;
		.coupon_list {
			display: flex;
			margin-bottom: 0.2rem;
			.left {
				position: relative;
				display: flex;
				flex-direction: column;
				align-items: center;
				.one {
					font-size: 0.4rem;
					top: 0.5rem;
					padding-left: 0.09rem;
				}
				.two {
					font-size: 0.22rem;
					top: 1.17rem;
					padding-left: 0.09rem;
				}
				img {
					width: 1.86rem;
				}

				div {
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
					color: #ffffff;
					position: absolute;
				}
			}
			.right {
				position: relative;
				display: flex;
				align-items: center;
				img {
					width: 4.79rem;
				}
				.one {
					position: absolute;
					height: 1.35rem;
					background: #fff;
					margin: 0.25rem;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 89%;
					padding: 0.18rem 0.3rem 0.2rem 0.2rem;
					border-radius: 0.04rem;
					/deep/.van-radio__icon {
						height: 0.32rem;
					}
					img {
						width: 0.32rem;
						height: 0.32rem;
					}
					.no_select {
						width: 0.3rem;
						height: 0.3rem;
						border: 0.01rem solid #20253a;
						border-radius: 50%;
					}
					.one_left {
						flex: 1;
						.van-radio-group {
							z-index: 9999;
						}
					}
				}
				.one_top {
					font-size: 0.24rem;
					font-family: PingFangSC-Semibold, PingFang SC;
					color: #666666;
					margin-bottom: 0.16rem;
					display: -webkit-box;
					word-break: break-all;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.one_bottom {
					font-size: 0.15rem;
					font-family: PingFangSC-Regular, PingFang SC;
					color: #999999;
					transform: scale(0.8);
					width: 130%;
					transform-origin: bottom left;
				}
			}
		}
		.title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 0.12rem;
			box-sizing: border-box;
			h1 {
				font-size: 0.32rem;
				margin: 0;
			}
			.right {
				display: flex;
				span {
					font-size: 0.24rem;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
					color: #9053f7;
					text-decoration: underline;
				}
				img {
					width: 0.36rem;
					margin-left: 0.24rem;
				}
			}
		}
		.sun_title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-weight: 600;
			color: #666666;
			padding: 0 0.12rem;
			h1 {
				font-size: 0.24rem;
			}
			.right {
				display: flex;
				align-items: center;
				font-size: 0.28rem;
			}
		}
		.listClass {
			max-height: 4rem;
			overflow-y: scroll;
			margin: 0.2rem 0 0.4rem;
			&::-webkit-scrollbar {
				display: none;
			}
		}
		.button_common {
			width: 2.5rem;
			height: 0.8rem;
			display: flex;
			font-size: 0.32rem;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			display: flex;
			justify-content: space-between;
			width: 100%;
			padding: 0 0.54rem;
			box-sizing: border-box;
			.button_left {
				background: none;
				border: 0.03rem solid #9053f7;
				color: #9053f7;
			}
			.button_right {
				background: #9053f7;
				color: #ffff00;
				border: none;
			}
		}
		button {
			height: 0.8rem;
			padding: 0 0.57rem;
			box-sizing: border-box;
			border-radius: 0.08rem;
		}
		.coupon_nine {
			display: flex;
			align-items: center;
			width: 100%;
			margin-top: 0.55rem;
		}
	}
</style>
